import React from 'react';
import styled from 'styled-components';

import { ResourceTableTitle, ResourceTableTitleContainer } from '@/components/common';
import { ResourceViewWithTabs } from './ResourceViewWithTabs';

interface IResourcesTabsTableContainerProps {
  defaultKey: string;
  tabs: { title: string; content: React.ReactElement; key: string }[];
  tableTitle: string;
  tableTitleActionSlot?: React.ReactElement;
}

const ResourcesTabsTableContainer = (props: IResourcesTabsTableContainerProps): React.ReactElement => {
  return (
    <>
      <ResourceTableTitleContainer>
        <ResourceTableTitle>{props.tableTitle}</ResourceTableTitle>
        {props.tableTitleActionSlot}
        <Separator />
      </ResourceTableTitleContainer>
      <StyledResourceViewWithTabs defaultKey={props.defaultKey} tabs={props.tabs} />
    </>
  );
};

export { ResourcesTabsTableContainer };

const Separator = styled.div`
  height: 1px;
  width: 100%;
  background-color: #00000010;
`;

const StyledResourceViewWithTabs = styled(ResourceViewWithTabs)`
  border-bottom: none;
`;
